import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { useController, Control } from 'react-hook-form';

type CustomTextAreaProps = TextFieldProps & {
  label?: string;
  name?: string;
  control?: Control<any>;
  rows?: number;
};

const BaseTextArea: React.FC<CustomTextAreaProps & { field?: any; fieldState?: any }> = (props) => {
  const { label, field, fieldState, onBlur: restOnBlur, onChange: restOnChange, rows = 4, ...rest } = props;

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const trimmed = e.target.value.trim();

    if (field) {
      // react-hook-form controlled field
      field.onChange(trimmed);
      field.onBlur();
    } else if (restOnChange) {
      //Create a synthetic change event with trimmed value
      const syntheticEvent = {
        target: { value: trimmed },
        currentTarget: { value: trimmed }
      } as React.ChangeEvent<HTMLInputElement>;
      restOnChange(syntheticEvent);
    }

    if (restOnBlur) {
      restOnBlur(e);
    }
  };

  return (
    <TextField
      label={label}
      variant="outlined"
      fullWidth
      multiline
      rows={rows}
      InputLabelProps={{ shrink: true }}
      autoComplete="off"
      {...field}
      onBlur={handleBlur}
      error={fieldState ? !!fieldState.error?.message : false}
      helperText={fieldState ? fieldState.error?.message : ''}
      onChange={field ? field.onChange : restOnChange}
      {...rest}
    />
  );
};

const ControlledTextArea: React.FC<CustomTextAreaProps> = (props) => {
  const { name, control } = props;
  const { field, fieldState } = useController({ name: name!, control: control! });
  return <BaseTextArea {...props} field={field} fieldState={fieldState} />;
};

const CustomTextArea: React.FC<CustomTextAreaProps> = (props) => {
  const { name, control } = props;
  return control && name ? <ControlledTextArea {...props} /> : <BaseTextArea {...props} />;
};

export default CustomTextArea; 